import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for Open Graph section
 * @param {Array} properties - The properties array from API
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (properties) => {
  if (!properties || properties?.length === 0) {
    return 'No Open Graph Tags were found.';
  }
  return null;
};

/**
 * Builds properties table from API properties array
 * @param {Array} properties - Array of { property, value } objects
 * @returns {Array} - Array of table row objects
 */
const buildPropertiesTable = (properties) => {
  if (!properties || properties?.length === 0) {
    return [];
  }

  return properties.map((item) => ({
    tag: item?.property || '',
    value: item?.value || '',
  }));
};

;

/**
 * Builds issues table from API issues array
 * @param {Array} issues - Array of { meta: { property }, type } objects
 * @returns {Array} - Array of table row objects for issues
 */
const buildIssuesTable = (issues) => {
  if (!issues || issues?.length === 0) {
    return [];
  }

  return issues.map((item) => ({
    property: item?.meta?.property || '',
    type: item?.type || '',
  }));
};

/**
 * Transforms the open_graph criteria from WooRank API response
 * @param {Object} openGraphCriteria - The open_graph criteria object from the API
 * @returns {Object} - Transformed Open Graph data for React components
 */
export const transformOpenGraph = (openGraphCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!openGraphCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Open Graph Tags were found.',
      data: null,
    };
  }

  const data = openGraphCriteria?.data || {};
  const wooRankStatus = openGraphCriteria?.status || 'neutral';
  const importance = openGraphCriteria?.importance || 0;
  const solvability = openGraphCriteria?.solvability || 0;

  const properties = data?.properties || [];
  const issues = data?.issues || [];

  const propertiesTable = buildPropertiesTable(properties);
  const issuesTable = buildIssuesTable(issues);

  const isEmpty = propertiesTable.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    hasIssues: issuesTable.length > 0,
    message: generateMessage(properties),
    data: isEmpty ? null : {
      propertiesTable,
      issuesTable,
    },
  };
};

export default transformOpenGraph;

